import { useState } from 'react'
import { ArrowLeft } from 'lucide-react'
import { LoginForm } from './LoginForm'
import { SignupForm } from './SignupForm'
import { useAuth } from '../../hooks/useAuth'
import { StockTaggerLogoBlack } from '../icons'

type AuthMode = 'login' | 'signup'

interface AuthScreenProps {
  onBackToLanding?: () => void
  initialMode?: AuthMode
}

export function AuthScreen({ onBackToLanding, initialMode = 'login' }: AuthScreenProps = {}) {
  const [mode, setMode] = useState<AuthMode>(initialMode)
  const { signIn, signUp, resetPassword, loading, error } = useAuth()

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center px-4 py-8 sm:px-6 lg:px-8">
      <div className="mx-auto w-full max-w-sm sm:max-w-md">
        {/* Back to Landing Button */}
        {onBackToLanding && (
          <button
            onClick={onBackToLanding}
            className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-6 transition-colors"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </button>
        )}

        <div className="text-center mb-6 sm:mb-8">
          <div className="flex justify-center mb-4">
            <StockTaggerLogoBlack className="w-16 h-16" />
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">StockTagger.ai</h1>
          <p className="text-sm sm:text-base text-gray-600 px-2">AI-Powered Stock Photo Metadata Generator</p>
        </div>
        
        {mode === 'login' ? (
          <LoginForm
            onLogin={signIn}
            onSwitchToSignup={() => setMode('signup')}
            onForgotPassword={resetPassword}
            loading={loading}
            error={error}
          />
        ) : (
          <SignupForm
            onSignup={signUp}
            onSwitchToLogin={() => setMode('login')}
            loading={loading}
            error={error}
          />
        )}
      </div>
    </div>
  )
}